var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCommunityCleaning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_63_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.9694 39.8145L30.9375 59.0623",
    stroke: "#393939",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.9144 58.5937L45.4688 43.5937L43.125 32.6868V26.4824",
    stroke: "#393939",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0312 33.75L36.0938 59.0625",
    stroke: "#393939",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0312 9.375C39.3612 9.375 41.25 7.4862 41.25 5.15625C41.25 2.8263 39.3612 0.9375 37.0312 0.9375C34.7013 0.9375 32.8125 2.8263 32.8125 5.15625C32.8125 7.4862 34.7013 9.375 37.0312 9.375Z",
    stroke: "#393939",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.694 20.4444L28.6334 25.9039L32.0195 33.0381C32.1899 33.3147 32.3013 33.6235 32.3469 33.9451C32.3926 34.2667 32.3713 34.5943 32.2846 34.9074C32.1979 35.2204 32.0476 35.5122 31.843 35.7646C31.6384 36.0169 31.384 36.2243 31.0956 36.3739C30.5715 36.6223 29.9766 36.6781 29.4154 36.5314C28.8542 36.3847 28.3627 36.0449 28.0273 35.5717L24.0902 28.1978C23.6041 27.2874 23.3483 26.2718 23.3452 25.2397C23.3422 24.2076 23.5919 23.1905 24.0725 22.2771L26.7369 17.2145C27.2196 16.1304 27.9868 15.1971 28.9572 14.514C29.9276 13.8308 31.0649 13.4232 32.2483 13.3344C34.0868 13.1948 35.5402 13.1251 37.0295 13.125C37.0295 13.125 41.2951 13.1331 41.4626 13.1489C42.6049 13.2899 43.6691 13.8028 44.491 14.6086C45.3128 15.4143 45.8467 16.4682 46.0102 17.6075L47.0403 23.9496C47.0403 24.5889 46.7863 25.2021 46.3342 25.6542C45.8821 26.1063 45.269 26.3603 44.6296 26.3603H37.401C36.7868 26.3735 36.1891 26.1606 35.7216 25.762C35.2541 25.3633 34.9493 24.8068 34.8653 24.1982C34.8306 23.8624 34.8667 23.5231 34.9714 23.2022C35.0761 22.8813 35.247 22.5859 35.4731 22.3353C35.6992 22.0846 35.9753 21.8842 36.2838 21.747C36.5922 21.6098 36.926 21.5389 37.2635 21.5388L42.3926 20.858",
    stroke: "#393939",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3973 36.7578L22.292 50.3816",
    stroke: "#393939",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2603 25.5117L31.7222 32.0864",
    stroke: "#393939",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2911 8.19336L37.5186 21.1824",
    stroke: "#393939",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7475 54.583L18.3072 57.0051C17.9445 57.6243 17.4277 58.1392 16.8071 58.4996C16.1865 58.8601 15.4832 59.0539 14.7656 59.0623",
    stroke: "#393939",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.49365 59.0626C10.2113 59.0542 10.9145 58.8604 11.5351 58.4999C12.1557 58.1395 12.6725 57.6246 13.0353 57.0054L16.7597 50.2776C17.058 49.7323 17.5607 49.3278 18.1572 49.1531C18.7538 48.9784 19.3953 49.0478 19.9406 49.3461L24.0531 51.5955C24.5985 51.8938 25.003 52.3965 25.1777 52.9931C25.3524 53.5896 25.2829 54.2311 24.9847 54.7765L23.548 57.3153C23.2575 57.8379 22.8343 58.2746 22.3211 58.5814C21.8079 58.8882 21.2229 59.0542 20.625 59.0626",
    stroke: "#393939",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.75 59.0627L55.7812 59.0195",
    stroke: "#393939",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0312 33.75L40.2872 45.1031L42.1997 59.0625",
    stroke: "#393939",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.4375 56.207C8.95527 56.207 9.375 55.7873 9.375 55.2695C9.375 54.7518 8.95527 54.332 8.4375 54.332C7.91973 54.332 7.5 54.7518 7.5 55.2695C7.5 55.7873 7.91973 56.207 8.4375 56.207Z",
    fill: "#393939"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.6875 54.375C5.20527 54.375 5.625 53.9553 5.625 53.4375C5.625 52.9197 5.20527 52.5 4.6875 52.5C4.16973 52.5 3.75 52.9197 3.75 53.4375C3.75 53.9553 4.16973 54.375 4.6875 54.375Z",
    fill: "#393939"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3125 52.5C10.8303 52.5 11.25 52.0803 11.25 51.5625C11.25 51.0447 10.8303 50.625 10.3125 50.625C9.79473 50.625 9.375 51.0447 9.375 51.5625C9.375 52.0803 9.79473 52.5 10.3125 52.5Z",
    fill: "#393939"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_63_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunityCleaning);
export default __webpack_public_path__ + "static/media/community-cleaning.7702a0b866d7c03bd67b1db17232e86e.svg";
export { ForwardRef as ReactComponent };